import React, { useContext, useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Navbar, Nav, Offcanvas, Container, Badge, Dropdown,DropdownButton,Button} from 'react-bootstrap';
import { FaSearch, FaShoppingBag, FaUser, FaBars, FaShoppingBasket, FaHeart, FaBook, FaBookOpen, FaHome, FaMoneyCheck, FaTransgenderAlt, FaExchangeAlt, FaArrowLeft, FaGreaterThan, FaAlignLeft, FaAngleLeft, FaCartPlus, FaUserCircle, FaWallet, FaShopify, FaShopware, FaList } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Header.css';
import { AuthContext } from '../context/AuthContext';
import { doc, getDoc,onSnapshot } from 'firebase/firestore';
import { db } from '../FireBase'; // Adjust the import based on your file structure
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAmericanSignLanguageInterpreting, faBaby, faBars, faBed, faCar, faCartShopping, faHouse, faMapMarked, faMapPin, faMobileScreenButton, faPaperPlane, faPeopleGroup, faPerson, faSearch, faShop, faShoppingBag, faShoppingBasket, faShoppingCart, faShopSlash, faStore, faTents, faUserAstronaut, faUserDoctor, faUserLarge, faUserNinja, faWallet } from '@fortawesome/free-solid-svg-icons';
import { faCircleUser, faUser, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import CartOffcanvas from './CartOffCanvas';
import MobileMenuOffCanvas from './MobileMenuOffCanvas';
import { House, CreditCard, Box, Calendar, LogOut, StoreIcon, Store, SearchIcon, ShoppingBag, Menu, BarChart, MenuIcon, Wallet, MapPin, MapPinCheckIcon, MapPinMinus, MapPinCheckInsideIcon, MapPinCheck, MapPinned, User2, TentTree, Bed, Ellipsis, EllipsisVertical, TicketCheck, Car, User2Icon, CarTaxiFront, CircleUserRound, MenuSquare, LucideMenu } from 'lucide-react';
import { MenuItem } from '@mui/material';
import { faTencentWeibo } from '@fortawesome/free-brands-svg-icons';





const MyNavbar = () => {
  const [showPincode, setShowPincode] = useState(false);
  const isMobile = window.innerWidth < 768;
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en'); // Default to English
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const navigate = useNavigate();
  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const handleCloseCart = () => setShowCart(false);
  const handleShowCart = () => setShowCart(true);

  const { currentUser  } = useContext(AuthContext);
  const [cartCount, setCartCount] = useState(0);
  const [userPincode,setUserPincode] = useState('');
  




  // const clearCart = () => {
  //   localStorage.removeItem("cart");
  //   // window.dispatchEvent(new Event("storage")); // Notify other components
  //   window.dispatchEvent(new Event("cartUpdated"));
  //   alert("Cart has been cleared!"); // Replace this with a toast if needed
  // };
  
  return (
    <>
    <Navbar expand="lg" sticky="top"  className={` navcusbg ${isNavbarVisible ? 'navbar-visible' : 'navbar-hidden'}`}>
        <Container fluid>

          <Navbar.Brand as={Link} to="/"  className="flex-grow-1" style={{ color: '#1c5f8b' , width:'auto'}}>
          <img  src="/Logo.png" alt="Logo" className='logo-size' /> 
          <span className='brand-text '>
            Kabili Holidays
          </span>
          </Navbar.Brand>
         
           {/* <Nav.Link  as={Link} to="/cab-and-rental"  aria-label="Toggle navigation" className="btn btn-link d-lg-none head-btns">
          <CircleUserRound size={28} />
          </Nav.Link> */}
          <Nav.Link onClick={handleShow} aria-label="Toggle navigation" className="btn btn-link d-lg-none head-btns">
          <LucideMenu size={28} />
          </Nav.Link>
         
            {/* {isMobile && (
        <div className="mobile-banner text-center py-2" style={{ backgroundColor: '#f1f1f1' }}>
          <small style={{ fontWeight: '500' }}>🎉 Free Shipping on orders over ₹499!</small>
        </div>
      )} */}

          <div className="d-none d-lg-flex align-items-center ">
          
            <Nav.Link as={Link} to="/"  className="d-flex align-items-center me-3 menu-text" style={{paddingRight:'20px'}}>
            <FontAwesomeIcon icon= {faHouse} size="xs" style={{marginRight:'3px'}}/> Home
            </Nav.Link>
            <Nav.Link as={Link} to="/rooms"  className="d-flex align-items-center me-3 menu-text" style={{paddingRight:'20px'}}>
            <FontAwesomeIcon icon= {faBed} size="xs" style={{marginRight:'3px'}}/>Rooms
            </Nav.Link>
            <Nav.Link as={Link} to="/tour-packages" className="d-flex align-items-center me-3 menu-text" style={{paddingRight:'20px'}}>
            <FontAwesomeIcon icon= {faTents} size="xs" style={{marginRight:'3px'}}/>Tour Packages
            </Nav.Link>
             <Nav.Link as={Link} to="/cab-and-rental" className="d-flex align-items-center me-3 menu-text" style={{paddingRight:'20px'}}>
            <FontAwesomeIcon icon= {faCar} size="xs" style={{marginRight:'3px'}}/>Cabs & rental
            </Nav.Link>
            
            <Nav.Link as={Link} to="/contact" className="d-flex align-items-center me-3 menu-text" style={{paddingRight:'20px'}}>
            <FontAwesomeIcon icon= {faPaperPlane} size="xs" style={{marginRight:'3px'}}/>Contact
            </Nav.Link>
            <Nav.Link as={Link} to="/account" className="d-flex align-items-center me-3 menu-text" style={{paddingRight:'20px'}}>
            <FontAwesomeIcon icon= {faUserNinja} size="xs" style={{marginRight:'3px'}}/>Account
            </Nav.Link>
          </div>
        </Container>
      </Navbar>
    

      {/* Offcanvas for Mobile Menu */}
      <MobileMenuOffCanvas
        show={showOffcanvas}
        handleClose={() => setShowOffcanvas(false)}

      />

    

      {/* Icons for Mobile */}
      <div className="d-lg-none fixed-bottom shadow-sm w-100 d-flex justify-content-around py-2 mob-own-nav mob-nav-cus">
        <Nav.Link as={Link} to="/"  className="d-flex flex-column align-items-center nav-icon mob-own-nav-link" >
        <House size={20} /><span style={{fontSize:'12px'}}>Home</span>
        </Nav.Link>
      
        <Nav.Link as={Link} to="/rooms" className="d-flex flex-column align-items-center mob-own-nav-link">
          <Bed size={20} /><span style={{fontSize:'12px'}}>Rooms</span>
        </Nav.Link>
        <Nav.Link as={Link} to="/tour-packages" className="d-flex flex-column align-items-center mob-own-nav-link">
         <TentTree size={20} /><span style={{fontSize:'12px'}}>Tour Packages</span>
        </Nav.Link>
          <Nav.Link as={Link} to="/cab-and-rental" className="d-flex flex-column align-items-center mob-own-nav-link">
         <CarTaxiFront size={20} /><span style={{fontSize:'12px'}}>Cabs & Rental</span>
        </Nav.Link>
       
        {/* <Nav.Link as={Link} to="/account" className="d-flex flex-column align-items-center mob-own-nav-link">
         <User2 size={20} /><span style={{fontSize:'12px'}}>My account</span>
        </Nav.Link> */}
        {/* <Nav.Link as={Link}to="/account"  state={{ tab: 'Bookings' }} className="d-flex flex-column align-items-center mob-own-nav-link">
         <TicketCheck size={20} /><span style={{fontSize:'12px'}}>My bookings</span>
        </Nav.Link> */}
      </div>
     
    </>
  );
};

export default MyNavbar;


